const Footer = () => {
    return (
        <footer className="d-flex justify-content-center align-items-center mt-5 p-5">
            <div className="container my-5 text-center">
                <small>
                    <strong className="fs-5">Let's talk</strong>
                    <p>
                        Do you want to get in touch or talk about a proyect? <br />
                        Fill free to fill to contact me via email at <strong>gabioh2012@gmail.com</strong> <br />
                        or drop a line in the form contact.

                    </p>

                </small>
            </div>
        </footer>


    )
}
export default Footer;